export default __webpack_public_path__ + "static/media/DaimlerCS-Regular.ba0d7a58.ttf";